import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController } from '@ionic/angular/lazy';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-parked-cart-options',
    templateUrl: './parked-cart-options.component.html',
    styleUrls: ['./parked-cart-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ParkedCartOptionsComponent implements OnInit {

    @Input() parked_cart_page = null;
    @Input() printer_paper_sizes = [];

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

    public presentParkedCartEmailModal() {
        this.parked_cart_page.presentParkedCartEmailModal();
        this.dismiss();
    }

    public printParkedCartQuote(printer_paper_size) {
        this.parked_cart_page.printParkedCartQuote(printer_paper_size);
        this.dismiss();
    }

    public printParkedCartJobSheet(printer_paper_size) {
        this.parked_cart_page.printParkedCartJobSheet(printer_paper_size);
        this.dismiss();
    }

    public unparkCart() {
        this.parked_cart_page.unparkCart();
        this.dismiss();
    }

    public duplicateCart() {
        this.parked_cart_page.duplicateCart();
        this.dismiss();
    }

    public deleteParkedCart() {
        this.parked_cart_page.deleteParkedCart();
        this.dismiss();
    }

    public presentParkedCartEditModal() {
        this.parked_cart_page.presentParkedCartEditModal();
        this.dismiss();
    }

}
